import { BuilderView } from '../types';

type WorkflowsForIntent = {
  api_workflow_id?: string | null;
  interactive_email_workflow_id?: string | null;
  playbook_workflow_id?: string | null;
  slack_workflow_id?: string | null;
  voice_workflow_id?: string | null;
  web_call_workflow_id?: string | null;
  widget_workflow_id?: string | null;
};

const workflowIdKeyByView: Record<
  Exclude<BuilderView, 'email'>,
  keyof WorkflowsForIntent
> = {
  api: 'api_workflow_id',
  playbook: 'playbook_workflow_id',
  slack: 'slack_workflow_id',
  voice: 'voice_workflow_id',
  web_call: 'web_call_workflow_id',
  widget: 'widget_workflow_id',
};

/** Resolves a channel workflow id without throwing when the channel is unset. */
export const getOptionalWorkflowId = (
  view: BuilderView,
  workflowsForIntent: WorkflowsForIntent | undefined,
): string | null => {
  if (!workflowsForIntent) {
    return null;
  }

  if (view === 'email') {
    return (
      workflowsForIntent.interactive_email_workflow_id ||
      workflowsForIntent.widget_workflow_id ||
      null
    );
  }

  return workflowsForIntent[workflowIdKeyByView[view]] || null;
};
